export default __webpack_public_path__ + "static/healthy-f5ed76de38e93bf0f7677864ef97c835.svg";